// Module
var code = `<div class="s-chip {{ ctrl.type ? 's-chip--' + ctrl.type : '' }}"> <span>{{ ctrl.text }}</span> <a ng-if="ctrl.showRemoveAction" href="#" ng-click="ctrl.remove(\$event)"> <i class="s-chip__remove n-i n-i-close ml-1"></i> </a> </div> `;
// Exports
var _module_exports =code;;
var path = '/common/components/chip/chip.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;